import qs from 'qs';

/**
 * Parse query params from url string.
 *
 * @example
 * parse('foo=bar&goo=car&hoo=dar')
 * => {foo: 'bar', goo: 'car', hoo: 'dar'}
 *
 * @param {string} value
 * @returns {object}
 */
export function parse(value) {
  return qs.parse(value.replace('?', ''));
}

/**
 * Stringify to url with query params.
 *
 * @example
 * stringify('link', { foo: 'bar', goo: 'car', hoo: 'dar' })
 * => 'link?foo=bar&goo=car&hoo=bar'
 * @param route
 * @param params
 * @param {object} value
 * @returns {string}
 */
export function stringify(route, params) {
  if (params === null || !(params instanceof Object) || Object.keys(params).length < 1) {
    return route;
  }

  return route + '?' + qs.stringify(params);
}

/**
 * Format the sort query params
 * @param {{orderBy:string, order:('asc'|'desc')}} sortQueryParam
 * @param {{orderBy:string, order:('asc'|'desc')}} defaultSortOption
 * @return {{orderBy:string, order:('asc'|'desc')}}
 */
export const formatSortQueryParam = (sortQueryParam, defaultSortOption = { orderBy: 'createdAt', order: 'desc' }) => {
  if (!sortQueryParam.orderBy || sortQueryParam.orderBy === '') {
    return defaultSortOption;
  }
  return {
    orderBy: sortQueryParam.orderBy,
    order: ['asc', 'desc'].includes(sortQueryParam.order) ? sortQueryParam.order : 'desc',
  };
};
